// Stacked-label outlined text field — matches GreenTextField / site onboarding (LDCP-138).
import React from "react";
import { styled } from "@mui/material/styles";

import { SafeTextField } from "../../../../../common/Greens";

const StyledAsecTextField = styled(SafeTextField)({
  width: "100%",
  "& .MuiInputBase-sizeSmall .MuiOutlinedInput-root": {
    minHeight: 40,
  },
  "& .MuiInputBase-sizeSmall:not(.MuiInputBase-multiline) input.MuiOutlinedInput-input": {
    paddingTop: "18px",
    paddingBottom: "4px",
    lineHeight: "20px",
  },
  "&.asec-text-field-compact .MuiInputBase-sizeSmall:not(.MuiInputBase-multiline) input.MuiOutlinedInput-input": {
    paddingTop: "8px",
    paddingBottom: "8px",
    lineHeight: "20px",
  },
  "& .MuiInputBase-sizeSmall .MuiInputLabel-shrink": {
    marginTop: "10px",
    paddingLeft: "11px!important",
  },
});

/** API Security text field — stacked internal label, white surface, indigo focus ring. */
export function AsecTextField({ compact = false, size = "small", variant = "outlined", sx, className, ...props }) {
  return (
    <StyledAsecTextField
      variant={variant}
      size={size}
      className={compact ? `asec-text-field-compact ${className || ""}`.trim() : className}
      sx={sx}
      {...props}
    />
  );
}

export default AsecTextField;
